import { useQuery } from '@tanstack/react-query';
import { guideReviewsApi, guideReviewsKeys } from '@/features/guide/api/guide-reviews.api';

export function useGuideReviews(params?: { page?: number; limit?: number }) {
  return useQuery({
    queryKey: guideReviewsKeys.mine(params),
    queryFn: () => guideReviewsApi.listMine(params),
  });
}
